import React from 'react';
import DataTable from 'react-data-table-component';
import CardHeader from "./CardHeader";
import DataTableSearch from "./DataTableSearch";
import AddButton from "./AddButton";
import HeaderContent from "./HeaderContent";
import { Link } from "react-router-dom";
import guLocale from "../locales/gu";

const LedgerListing = ({ columns, data, filterText, handleFilterChange, handleShow, totalGrant, usedGrant, remainingGrant }) => {
  const locale = guLocale.ledgerListing;
  const localeGlobal = guLocale.global;
  const paginationComponentOptions = {
    rowsPerPageText: localeGlobal.rowsPerPageText, // Gujarati text for "Rows per page"
    rangeSeparatorText: localeGlobal.rangeSeparatorText, // Gujarati text for "of"
    selectAllRowsItem: true,
    selectAllRowsItemText: localeGlobal.selectAllRowsItemText, // Gujarati text for "All"
  };

  return (
    <div>
      <div className="content-wrapper">
        <div className="content-header">
          <div className="container-fluid">
            <div className="row mb-2">
              <div className="col-sm-6">
                <h1 className="m-0">{locale.title}</h1>
              </div>
              <div className="col-sm-6">
                <ol className="breadcrumb float-sm-right">
                  <li className="breadcrumb-item">
                    <Link to="/dashboard">{locale.homeBreadcrumb}</Link>
                  </li>
                  <li className="breadcrumb-item active">{locale.ledgersBreadcrumb}</li>
                </ol>
              </div>
            </div>
          </div>
        </div>
        <section className="content">
          <div className="container-fluid">
            <div className="row">
              <div className="col-12 col-sm-4">
                <div className="small-box bg-success">
                  <div className="inner">
                    <h3>
                      {totalGrant}
                      <sup style={{ fontSize: 20 }}></sup>
                    </h3>
                    <p>{locale.totalGrants}</p>
                  </div>
                  <div className="icon">
                    <i className="ion ion-android-arrow-down custom-ion-icon"/>
                  </div>
                </div>
              </div>
              <div className="col-12 col-sm-4">
                <div className="small-box bg-danger">
                  <div className="inner">
                    <h3>{usedGrant}</h3>
                    <p>{locale.totalUsedGrants}</p>
                  </div>
                  <div className="icon">
                    <i className="ion ion-android-arrow-up custom-ion-icon"/>
                  </div>
                </div>
              </div>
              <div className="col-12 col-sm-4">
                <div className="small-box bg-info">
                  <div className="inner">
                    <h3>{remainingGrant}</h3>
                    <p>{locale.totalRemainingGrants}</p>
                  </div>
                  <div className="icon">
                    <i className="ion ion-ios-calculator custom-ion-icon"/>
                  </div>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-12">
                <div className="card">
                  <CardHeader className="card-header">
                    <HeaderContent>
                      <DataTableSearch filterText={filterText} handleFilterChange={handleFilterChange} />
                    </HeaderContent>
                    <AddButton onClick={handleShow} text={locale.addLedgerButtonText}/> 
                  </CardHeader>
                  <div className="card-body">
                    <DataTable
                      pagination
                      columns={columns}
                      data={data} // Use filteredData here
                      noDataComponent={localeGlobal.noRecordsToDisplayLabel}
                      paginationComponentOptions={paginationComponentOptions}
                      highlightOnHover
                      striped
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>
  );
};

export default LedgerListing;